var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.262,
    height: 11.262,
    viewBox: "0 0 11.262 11.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-certification",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M122.011,60l.641,1.207,1.37.167-1.006.906.2,1.341-1.207-.754-1.207.754.2-1.341L120,61.373l1.408-.167Z",
    transform: "translate(-100.76 -44.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M20.044,112.826h-.8v-2.011a2.013,2.013,0,0,0-2.011-2.011H14.815a2.013,2.013,0,0,0-2.011,2.011v2.011H12v-2.011A2.819,2.819,0,0,1,14.815,108h2.413a2.819,2.819,0,0,1,2.815,2.815Z",
    transform: "translate(0 -89.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M32.815,12.8A2.011,2.011,0,1,1,30.8,14.815,2.011,2.011,0,0,1,32.815,12.8m0-.8a2.815,2.815,0,1,0,2.815,2.815A2.815,2.815,0,0,0,32.815,12Z",
    transform: "translate(-16.793 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingStatus);
export default __webpack_public_path__ + "static/media/Onboarding Status.a63a512a267ce4b7e1f663fe507e6d6e.svg";
export { ForwardRef as ReactComponent };